import React from 'react'
import styled from 'styled-components'
import moment from 'moment'

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom 24px;
`

const Code = styled.div`
  border: 2px solid;
  color: ${({ theme }) => theme?.['-ds-core-400']?.value};
  border-color: ${({ theme }) => theme?.['-ds-core-400']?.value};
  background-color: ${({ theme }) => theme?.['-ds-neutral-200']?.value};
  font-size: ${({ theme }) =>
    theme?.['-ds-font-size-lg']?.['font-size']?.value};
  font-weight: 400;
  text-align: center;
  border-radius: 8px;
  padding: 16px;
  width: 100%;
  margin-top: 6px;
`

const Expiry = styled.div`
  color: ${({ theme }) => theme?.['-ds-core-400']?.value};
  margin-top: 8px;
`

type VoucherProps = {
  voucher: GQL_GetCustomerReferralQuery['customerReferral']['referralVoucher']
}

const Voucher = ({ voucher }: VoucherProps) => {
  return (
    <Wrapper>
      <Code>{voucher.code}</Code>
      <Expiry>
        Expiry Date: {moment(voucher.expiresAt).format('DD MMM YYYY')}
      </Expiry>
    </Wrapper>
  )
}

export default Voucher
